<template>
  <section class="match-signup-flow-section">
    <img class="signup-flow-title" :src="flowData.titleImage" alt="流程安排" />
    <img class="signup-flow-title-mobile" :src="flowData.mobileTitleImage || flowData.titleImage" alt="流程安排" />

    <div class="signup-flow-board">
      <img class="signup-flow-board-image" :src="flowData.boardImage" alt="报名流程" />
      <img class="signup-flow-character" :src="flowData.characterImage" alt="" />

      <div class="signup-flow-steps">
        <div v-for="step in flowData.steps" :key="step.title" class="signup-flow-step">
          <h3>{{ step.title }}</h3>
          <p v-for="line in step.lines" :key="line">{{ line }}</p>
        </div>
      </div>
    </div>

    <div class="signup-flow-board-mobile">
      <img class="signup-flow-board-mobile-image" :src="flowData.mobileBoardImage || flowData.boardImage" alt="报名流程" />
      <img class="signup-flow-character-mobile" :src="flowData.mobileCharacterImage || flowData.characterImage" alt="" />

      <div class="signup-flow-steps-mobile">
        <div v-for="step in flowData.steps" :key="`${step.title}-mobile`" class="signup-flow-step-mobile">
          <h3>{{ step.title }}</h3>
          <p v-for="line in step.lines" :key="line">{{ line }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MatchSignupFlowSection',
  props: {
    flowData: { type: Object, required: true },
  },
}
</script>

<style scoped lang="scss">
.match-signup-flow-section {
  width: 10rem;
  margin: 0.598958rem auto 0;

  .signup-flow-title-mobile,
  .signup-flow-board-mobile {
    display: none;
  }

  .signup-flow-title {
    display: block;
    width: 5.729167rem;
    height: 1.114583rem;
    margin: 0 auto;
  }

  .signup-flow-board {
    position: relative;
    width: 7.291667rem;
    height: 3.885417rem;
    margin: 0.182292rem auto 0;

    .signup-flow-board-image {
      display: block;
      width: 7.291667rem;
      height: 3.885417rem;
    }

    .signup-flow-character {
      position: absolute;
      top: 0.177083rem;
      right: -0.666667rem;
      width: 4.833333rem;
      height: 3.692708rem;
      pointer-events: none;
    }

    .signup-flow-steps {
      position: absolute;
      top: 0.655208rem;
      left: 0.713542rem;
      z-index: 1;
      width: 2.864583rem;
    }

    .signup-flow-step {
      box-sizing: border-box;
      padding: 0.0625rem 0.130208rem 0.09375rem;
      border-radius: 0.104167rem;
      background: rgba(86, 0, 0, 0.5);
      color: #ffffff;

      & + .signup-flow-step {
        margin-top: 0.088542rem;
      }

      &:nth-child(1) {
        min-height: 0.885417rem;
      }

      &:nth-child(2),
      &:nth-child(3) {
        min-height: 0.729167rem;
      }

      h3 {
        height: 0.197917rem;
        margin: 0;
        color: #ffe69e;
        font-size: 0.104167rem;
        font-weight: 700;
        line-height: 0.197917rem;
      }

      p {
        margin: 0;
        font-size: 0.083333rem;
        line-height: 0.145833rem;

        & + p {
          margin-top: 0.005208rem;
        }
      }
    }
  }
}

@media (max-width: 750px) {
  .match-signup-flow-section {
    width: 100%;
    margin: 0;
    padding-bottom: 0.4rem;

    .signup-flow-title {
      display: none;
    }

    .signup-flow-title-mobile {
      display: block;
      width: 9.333333rem;
      height: 1.813333rem;
      margin: 0 auto;
    }

    .signup-flow-board {
      display: none;
    }

    .signup-flow-board-mobile {
      position: relative;
      display: block;
      box-sizing: border-box;
      width: 10rem;
      min-height: 9.4rem;
      height: auto;
      margin-top: -0.24rem;
      padding: 1.386667rem 0 0.72rem;

      .signup-flow-board-mobile-image {
        position: absolute;
        inset: 0;
        z-index: 0;
        display: block;
        width: 100%;
        height: 100%;
        object-fit: fill;
        pointer-events: none;
      }

      .signup-flow-character-mobile {
        position: absolute;
        right: -0.853333rem;
        bottom: 0.586667rem;
        z-index: 1;
        width: 5.626667rem;
        height: 4.293333rem;
        pointer-events: none;
      }

      .signup-flow-steps-mobile {
        position: relative;
        z-index: 2;
        display: flex;
        flex-direction: column;
        gap: 0.16rem;
        width: 6.16rem;
        margin-left: 0.64rem;
      }

      .signup-flow-step-mobile {
        box-sizing: border-box;
        width: 100%;
        min-height: 0;
        padding: 0.16rem 0.213333rem 0.186667rem;
        border-radius: 0.133333rem;
        background: rgba(86, 0, 0, 0.5);
        color: #ffffff;

        h3 {
          margin: 0 0 0.106667rem;
          color: #ffe69e;
          font-size: 0.32rem;
          font-weight: 700;
          line-height: 0.373333rem;
        }

        p {
          margin: 0;
          font-size: 0.293333rem;
          line-height: 0.346667rem;
          overflow-wrap: break-word;

          & + p {
            margin-top: 0.026667rem;
          }
        }
      }
    }
  }
}
</style>
